import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  User,
} from 'lingo2-models';
import { map, Observable, of, ReplaySubject } from 'rxjs';
import { GameService } from './game.service';


@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private _subscribed: { [key: string]: ReplaySubject<boolean> } = {};

  public constructor(
    private http: HttpClient,
    private gameService: GameService,
  ) {
  }

  public static accountRoute(account: Partial<User>, extra: string[] = []): string[] {
    if (account) {
      return ['/u', account.slug!, ...extra];
    } else {
      return [];
    }
  }

  public static getUserName(user: Partial<User>): string {
    if (!user) {
      return '';
    }
    const first_names = (user.first_name || '').split(/\s+/).filter((s) => s.length);
    const last_name = (user.last_name || '').trim();

    return [first_names[0] || '', last_name].filter((s) => s.length).join(' ');
  }

  public static getUserCropName(user: Partial<User>): string {
    if (!user) {
      return '';
    }
    const first_name = (user.first_name || '').trim();
    const last_name = (user.last_name || '').trim();

    return `${first_name[0]}. ${last_name}`;
  }

  public static getUserFullName(user: Partial<User>): string {
    if (!user) {
      return '';
    }

    return [user.first_name || '', user.last_name || ''].join(' ').replace(/\s+/g, ' ').trim();
  }

  public static getUserEditedName(user: Partial<User>): string {
    if (!user) {
      return '';
    }
    const firstName = (user.first_name || '').substring(0, 1) + '.';
    return [firstName, user.last_name || ''].join(' ').replace(/\s+/g, ' ').trim();
  }

  public getUserById(user_id: string): Observable<User> {
    if (!user_id) {
      return of();
    }
    const url = `https://${this.gameService.host}/web/account/account/${user_id}`;
    const params = new HttpParams();
    return this.http.get<User>(url, { params, observe: 'response' })
      .pipe(map((response: any) => response.body));
  }
}
